module.exports = __webpack_public_path__ + "img/logo-dark.400b9dac.jpg";